import { formatListingDate, formatRelativeDate } from '../../utils/FormatDate';

// Date column of the sales / invoices / payments / returns listings: the exact date and time,
// with the relative age ("il y a 11 minutes") small and gray underneath
const DateCell = ({ date }) => {
    if (!date) return <span className="cell-muted">—</span>;
    return (
        <div style={{ whiteSpace: 'nowrap' }}>
            <span style={{ fontSize: 13.5, fontWeight: 500, color: '#1f2937' }}>{formatListingDate(date)}</span>
            <span className="cell-sub" style={{ display: 'block' }}>{formatRelativeDate(date)}</span>
        </div>
    );
};

export default DateCell;
